import React, { Suspense, lazy } from 'react';
import Loading from '../LoadingComponent';

const QuestionFinder = lazy(() =>
  import(/* webpackChunkName: "QuestionFinder" */ '../../components/profile_questions/QuestionFinder')
);

export default function QuestionFinderComponent({...props}) {
  return (
    <Suspense fallback={<Loading />}>
      <QuestionFinder {...props} />
    </Suspense>
  );
}
